import Repository from '../../../Repository';

const resource = '/shopify/products/product';

export default {
  getProduct(region, productId) {
    return Repository.get(`${resource}/${productId}`, {
      params: {
        region,
      },
    });
  },
  searchProductHandle(region, handle) {
    return Repository.get(`${resource}`, {
      params: {
        'handle': handle,
        'region': region,
      },
    });
  },
};
